export default {"src":"/_next/static/media/RCL.11b4213e.svg","height":18,"width":18};